<template>
  <div class="pages">
    <div class="filter">
      <div>
        <el-form size="small" :inline="true">
          <el-form-item label="学校所在地">
            <el-cascader
              size="small"
              :options="options"
              v-model="selectedOptions"
              @change="handleChange"
            >
            </el-cascader>
            <el-button type="primary" @click="addSchoolPop">新增</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="search">
        <el-form size="small" :inline="true">
          <el-form-item label="关键字">
            <el-input
              v-model="formInline.keyWord"
              placeholder="请输入关键词查询"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="searcList">搜索</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="table">
      <el-table :data="tableData" height="5.7rem" max-height="5.7rem">
        <el-table-column type="index" label="序号" align="center" width="50">
        </el-table-column>
        <el-table-column property="name" label="学校名称" align="center">
        </el-table-column>
        <el-table-column property="address" label="学校所在地" align="center">
        </el-table-column>
        <el-table-column property="xyCount" label="校友人数" align="center">
        </el-table-column>
        <el-table-column property="jzgCount" label="学校教职工" align="center">
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          property="glY_XJ"
          label="校级管理员"
          align="center"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.glY_XJ.length <= 0">暂无</span>
            <span v-else v-for="(v, i) in scope.row.glY_XJ" :key="i"
              >{{ v.name }}
              <span v-if="i < scope.row.glY_XJ.length - 1">、</span>
            </span>
          </template>
        </el-table-column>
        <el-table-column label="学校个人管理员" align="center">
          <template slot-scope="scope">
            <el-link
              type="primary"
              :disabled="!scope.row.glY_XY.length"
              @click="adminDetail(scope.row, 2)"
              >{{ `${scope.row.glY_XY.length}人` }}</el-link
            >
            <!-- <span v-if="scope.row.glY_XY.length <= 0">暂无</span>
            <span v-else v-for="(v, i) in scope.row.glY_XY" :key="i"
              >{{ v.name }}
              <span v-if="i < scope.row.glY_XY.length - 1">、</span>
            </span> -->
          </template>
        </el-table-column>
        <el-table-column label="学校教职工管理员" align="center">
          <template slot-scope="scope">
            <el-link
              type="primary"
              :disabled="!scope.row.glY_JZG.length"
              @click="adminDetail(scope.row, 1)"
              >{{ `${scope.row.glY_JZG.length}人` }}</el-link
            >
            <!-- <span v-if="scope.row.glY_JZG.length <= 0">暂无</span>
            <span
              v-else
              v-for="(v, i) in scope.row.glY_JZG"
              :key="i"
              style="margin-right: 0.1rem"
              >{{ v.name }}</span
            > -->
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button @click="handleClick(scope.row)" type="text" size="medium"
              >学院专业</el-button
            ><el-button
              @click="editHandleClick(scope.row)"
              type="text"
              size="medium"
              >编辑</el-button
            ><el-button
              v-if="$store.state.userinfo.isSuper"
              @click="deleteSchool(scope.row)"
              type="text"
              size="medium"
              style="color: #f56c6c"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="pages justify-end">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="currentSize"
          layout="  prev, pager, next,  sizes, jumper"
          :total="totalCount"
        >
        </el-pagination>
      </div>
    </div>
    <el-dialog
      title="学校详情"
      :visible.sync="centerDialogVisible"
      :destroy-on-close="true"
      width="50%"
      center
    >
      <shoolDetail
        ref="schoolDetail"
        :closeDetials="closeDetials"
        :getSchoolList="getSchoolList"
        :currSchoolInfo="currSchoolInfo"
        :isEdit="true"
      ></shoolDetail>
      <span slot="footer" class="dialog-footer">
        <el-button @click="amendDetials" type="primary" size="medium"
          >修 改</el-button
        >
        <el-button @click="closeDetials">关 闭</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="学院专业"
      :visible.sync="collegeMajorVisible"
      :destroy-on-close="true"
      width="50%"
      center
    >
      <collegeMajor :schoolId="currSchoolInfo.id"></collegeMajor>
      <span slot="footer" class="dialog-footer">
        <el-button @click="collegeMajorVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="新增学校"
      :visible.sync="collegeAddVisible"
      :destroy-on-close="true"
      @close="close"
      width="50%"
      center
    >
      <div class="contentList">
        <template>
          <div style="padding: 0 5%; margin: 0.3rem auto 0.2rem">
            <el-row :gutter="50">
              <el-col :span="14">
                <el-form ref="form" label-width="1rem">
                  <el-form-item label="学校名称:">
                    <el-input v-model="addSchoolInfo.name"></el-input>
                  </el-form-item>
                  <el-form-item label="所在地区:">
                    <el-cascader
                      :options="options"
                      v-model="addSchoolInfo.schoolProvinceCode"
                      @change="handleChange2"
                    >
                    </el-cascader>
                  </el-form-item>
                  <el-form-item label="街道地址:">
                    <el-input v-model="addSchoolInfo.schoolAddress"></el-input>
                  </el-form-item>
                  <el-form-item label="联系电话:">
                    <el-input v-model="addSchoolInfo.schoolPhone"></el-input>
                  </el-form-item>
                </el-form>
              </el-col>
              <el-col :span="10">
                <el-form ref="form" label-width="80px">
                  <el-form-item label="校徽:">
                    <el-upload
                      class="upload-demo"
                      :on-change="fileChange"
                      :on-preview="handlePreview"
                      :on-success="uploadSuccess"
                      :on-remove="handleRemove"
                      :action="uploadConfig.uploadurl"
                      :headers="uploadConfig.uploadHeaders"
                      :file-list="uploadConfig.fileList"
                      accept=".jpg,.png"
                      list-type="picture"
                    >
                      <el-button size="small" type="primary"
                        >点击上传</el-button
                      >
                      <div slot="tip" class="el-upload__tip">
                        只能上传jpg/png文件，且不超过500kb
                      </div>
                    </el-upload>
                  </el-form-item>
                </el-form>
              </el-col>
            </el-row>
          </div>
        </template>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="medium" @click="addSchool"
          >新 增</el-button
        >
        <el-button @click="close">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  GetPowerApi,
  GetAttestationSchoolListApi,
  SelectSchoolApi
} from "@/request/requestApi";
import shoolDetail from "../../components/userDetail/shool.vue"; //学校详情
import collegeMajor from "../../components/collegeMajor.vue"; //学校详情
import { provinceAndCityDataPlus, CodeToText } from "element-china-area-data";
export default {
  data() {
    return {
      collegeAddVisible: false,
      collegeMajorVisible: false,
      centerDialogVisible: false,
      tableData: [],
      //文件上传信息
      uploadConfig: {
        //文件上传
        uploadurl: "",
        //文件列表
        fileList: [],
        uploadHeaders: {
          Authorization: localStorage.getItem("token")
        }
      },
      formInline: {
        keyWord: ""
      },
      //省市联级
      options: provinceAndCityDataPlus,
      selectedOptions: [],
      address: ["", ""],
      //翻页
      currentPage: 1,
      currentSize: 10,
      totalCount: 0,
      //当前学校信息
      currSchoolInfo: {},

      //添加学校信息
      addSchoolInfo: {
        name: "",
        logo: "",
        schoolProvinceCode: "",
        schoolProvince: [],
        schoolAddress: "",
        schoolPhone: ""
      }
    };
  },
  created() {
    this.getSchoolList();
    this.uploadConfig.uploadurl = `${window.api.apiurl}/api/Common/UploadFile`;
  },
  methods: {
    async adminDetail(row, adminType) {
      let res = await GetPowerApi();
      if (res.succeed) {
        this.$store.commit(
          "setNavIndex",
          this.findIndexPath(res.data, "管理员管理")
        );
        this.$router.push({
          name: "admin",
          params: { adminType: adminType, schoolId: row.id }
        });
      }
    },
    findIndexPath(data, targetName, path = []) {
      for (let i = 0; i < data.length; i++) {
        const item = data[i];
        // 如果当前项的名称匹配目标名称，返回当前路径
        if (item.name === targetName) {
          return [...path, i];
        }
        // 如果有子项，递归查找
        if (item.children && item.children.length > 0) {
          const result = this.findIndexPath(item.children, targetName, [
            ...path,
            i
          ]);
          if (result) {
            return result;
          }
        }
      }
      // 如果没有找到，返回 null
      return null;
    },
    searcList() {
      this.currentPage = 1;
      this.getSchoolList(this.currentPage);
    },
    getSchoolList(pageIndex = 1, pageSize = 10) {
      var params = {
        PageIndex: pageIndex,
        PageSize: pageSize,
        Keyword: this.formInline.keyWord,
        province: this.address[0],
        city: this.address[1]
      };

      var url = this.$dataConver.getUrl("/admin/School/GetSchoolList", params);

      this.$api.get(url).then(res => {
        if (res.succeed) {
          this.tableData = res.data.items;
          this.totalCount = res.data.total;
          this.tableData.forEach(element => {
            element.address = element.schoolProvince + element.schoolCity;
          });

          if (this.tableData.length <= 0 && this.currentPage > 1) {
            this.getSchoolList(--this.currentPage);
          }
        } else {
          this.$message.error(res.error);
        }
      });
    },
    //新增学校
    addSchoolPop() {
      this.collegeAddVisible = true;
    },
    //添加学校
    addSchool() {
      if (this.$dataConver.isNull(this.addSchoolInfo.name)) {
        this.$message.error("请输入学校名称！");
        return false;
      }
      if (this.$dataConver.isNull(this.addSchoolInfo.schoolProvince[0])) {
        this.$message.error("请选择学校所在省份！");
        return false;
      }
      if (this.$dataConver.isNull(this.addSchoolInfo.schoolProvince[1])) {
        this.$message.error("请选择学校所在城市！");
        return false;
      }
      if (this.$dataConver.isNull(this.addSchoolInfo.schoolAddress)) {
        this.$message.error("请输入学校街道地址！");
        return false;
      }
      if (this.$dataConver.isNull(this.addSchoolInfo.schoolPhone)) {
        this.$message.error("请输入学校联系电话！");
        return false;
      }
      if (
        /^1[34578]\d{9}$/.test(this.addSchoolInfo.schoolPhone) == false &&
        /([0-9]{3,4}-)?[0-9]{7,8}/.test(this.addSchoolInfo.schoolPhone) == false
      ) {
        this.$message.error("请输入正确的联系电话！");
        return false;
      }
      if (this.$dataConver.isNull(this.addSchoolInfo.logo)) {
        this.$message.error("请上传学校校徽！");
        return false;
      }
      this.$api
        .post("/admin/School/AddSchool", {
          name: this.addSchoolInfo.name,
          logo: this.addSchoolInfo.logo,
          schoolProvince: this.addSchoolInfo.schoolProvince[0],
          schoolCity: this.addSchoolInfo.schoolProvince[1],
          schoolAddress: this.addSchoolInfo.schoolAddress,
          schoolPhone: this.addSchoolInfo.schoolPhone
        })
        .then(res => {
          if (res.succeed) {
            this.$message.success("操作成功！");
            this.address = [];
            this.close();
            this.getSchoolList();
          } else {
            this.$message.error(res.error);
          }
        });
    },
    //删除学校
    deleteSchool(val) {
      this.$confirm("确认删除此学校吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$api.get("/admin/School/DeleteSchool?id=" + val.id).then(res => {
            if (res.succeed) {
              this.$message.success("操作成功！");
              this.getSchoolList();
            } else {
              this.$message.error(res.error);
            }
          });
        })
        .catch(() => {});
    },
    //关闭 清空添加信息
    close() {
      this.collegeAddVisible = false;
      this.addSchoolInfo = {
        name: "",
        logo: "",
        schoolProvinceCode: "",
        schoolProvince: [],
        schoolAddress: "",
        schoolPhone: ""
      };
      this.uploadConfig.fileList = [];
    },
    //关闭编辑详情
    closeDetials() {
      this.centerDialogVisible = false;
    },
    //修改
    amendDetials() {
      this.$refs.schoolDetail.editSchool();
    },
    handleClick(data) {
      this.currSchoolInfo = data;
      this.collegeMajorVisible = true;
    },
    //编辑学校  按钮
    editHandleClick(data) {
      this.centerDialogVisible = true;
      this.$api.get("/admin/School/GetSchoolInfo?id=" + data.id).then(res => {
        if (res.succeed) {
          this.currSchoolInfo = res.data;
        } else {
          this.$message.error(res.error);
        }
      });
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.currentPage = 1;
      this.currentSize = val;
      this.getSchoolList(this.currentPage, this.currentSize);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.getSchoolList(this.currentPage, this.currentSize);
    },
    handleChange(value) {
      var dz = [];
      if (value[1] != null) {
        dz.push(CodeToText[value[0]]);
        if (CodeToText[value[1]] == "全部") dz.push("");
        else dz.push(CodeToText[value[1]]);
      } else {
        if (CodeToText[value[0]] == "全部") dz.push("");
        else dz.push(CodeToText[value[0]]);
      }
      this.address = dz;
      console.log(this.address);
    },
    handleChange2(value) {
      var dz = [];
      if (value[1] != null) {
        dz.push(CodeToText[value[0]]);
        if (CodeToText[value[1]] == "全部") dz.push("");
        else dz.push(CodeToText[value[1]]);
      } else {
        if (CodeToText[value[0]] == "全部") dz.push("");
        else dz.push(CodeToText[value[0]]);
      }
      this.addSchoolInfo.schoolProvince = dz;
      console.log(this.addSchoolInfo.schoolProvince);
    },
    //文件改变钩子函数
    fileChange(file, fileList) {
      // 这是关键一句
      if (fileList.length > 0) {
        this.uploadConfig.fileList = [fileList[fileList.length - 1]];
      }
    },
    //已上传的文件时的钩子
    handlePreview(file) {
      console.log(file);
    },
    //文件上传成功
    uploadSuccess(file, fileList) {
      console.log(file.data);
      console.log(fileList);
      console.log(this.uploadConfig.fileList);
      this.addSchoolInfo.logo = file.data;
    },
    //移除文件
    handleRemove(file, fileList) {
      console.log(file, fileList);
      console.log(this.uploadConfig.fileList);
      this.addSchoolInfo.logo = "";
    }
  },
  components: {
    shoolDetail,
    collegeMajor
  }
};
</script>
<style lang="scss" scoped>
.contentList {
  img.headerImg {
    border: 1px solid #dedede;
    width: 1rem;
    height: 1rem;
    background: #eeeeee;
    box-sizing: border-box;
    border-radius: 50%;
  }
  .names {
    span {
      min-width: 0.6rem;
      white-space: nowrap;
      display: inline-block;
    }
  }
}
.table {
  margin-top: 0.2rem;
  padding: 0.24rem 0.19rem 0.3rem 0.2rem;
  background-color: rgb(255, 255, 255);
  border-radius: 0.05rem;
}
.filter {
  margin-top: 0.3rem;
  padding: 0.25rem 0.19rem 0.23rem 0.2rem;
  background-color: rgb(255, 255, 255);
  border-radius: 0.05rem;
  display: flex;
  justify-content: space-between;
  >>> .el-form-item {
    margin-bottom: 0;
  }
}
.section {
  padding: 0.23rem 0.18rem 0.57rem;
  flex: 1 1 2.4rem;
  border-radius: 0.06rem;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  height: 1.4rem;
  .name {
    color: rgb(102, 102, 102);
    font-size: 0.18rem;
    font-family: Microsoft YaHei;
    line-height: 0.17rem;
  }
  .number {
    margin-top: 0.17rem;
    color: rgb(51, 51, 51);
    font-size: 0.32rem;
    font-family: Microsoft YaHei;
    line-height: 0.26rem;
  }
}

.contentList .el-cascader {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/view/userManagement/shool.vue